export default {
  Role: "Role",
  action: "action",
  activation_date: "Activation date",
  active: "active",
  add: "tambah",
  addAlbumName: "tambah nama album",
  addSelectedToClaimList: "Tambah ke claim workspace",
  addedToClaimList: "Added to Claim List",
  additional_data: "additional data",
  additions_pct: "Additions percentage",
  address: "alamat",
  agent: "agent",
  airdatetime: "waktu tanggal udara",
  all_fields_must_be_filled: "All Fields must be filled!",
  artist: "artis",
  auto_manually_matched: "auto manually matched",
  automatched: "automatched",
  automatchedCheckboxInfo: "Select this to re-match the already matched usages as well (manual matches won’t be re-matched).",
  blocked: "blocked",
  cancel: "Batal",
  chooseFileOrDrag: "pilih file atau geser file kesini",
  choose_mandates_before_activation: "Please choose mandates before activating user",
  claim: "claim",
  claimAll: "claim semua",
  claimPercentage: "claim %",
  claimStatus: "status claim",
  claimWorkspace: "Claim workspace",
  claim_edited: "Claim Edited",
  claimed: "claimed",
  claiming: "claiming",
  claims: "claims",
  clear: "clear",
  clearFilters: "hapus filters",
  clear_all: "clear all",
  collapse: "collapse",
  companyName: "nama perusahaan",
  company_profile: "profile perusahaan",
  confirm_finalize_distribution: "Please note that finalising the distribution will publish the individual distribution reports to your members and you will no longer be able to change them. Would you like to proceed?",
  confirm_validate: "confirm validate",
  congratulations: "selamat",
  continue: "lanjutkan",
  create: "create",
  createNewSoundRecording: "buat sound recording baru",
  createPlaceholder: "buat placeholder",
  create_user: "buat pengguna",
  create_user_for: "Create user for",
  created: "Tanggal dibuat",
  date: "date",
  deduction_pct: "deduction %",
  defaultMatchingInfo: "By default, only the unmatched usages will be matched again.",
  delete: "hapus",
  deleteClaims: "batch delete claims",
  delete_distribution: "Hapus Distribusi",
  delete_distribution_warning: "Apakah Anda yakin ingin menghapus distribusi ini?",
  deleted: "deleted",
  dismiss: "dismiss",
  distribution: "distribusi",
  distribution_deleted: "distribution deleted",
  distribution_saved: "Distribution saved",
  distributions: "Distribusi",
  domestic: "domestik",
  download: "download",
  downloadFile: "download file",
  downloadSampleFile: "download sample file",
  downloadSampleFileNote: "NOTE: Sample file depend on the use type selected, previously downloaded files could not work",
  downloadTemplate: "unduh template",
  duration: "durasi",
  editClaim: "edit claim",
  editClaims: "batch edit claims",
  editDistribution: "edit distribution",
  editDistributionForFile: "Edit distribusi untuk fund file",
  edit_org: "edit profile perusahaan",
  email: "email",
  email_format_not_valid: "format email salah",
  email_not_defined: "email belum ditentukan",
  email_sent: "Email sent",
  error: "error",
  errors: "Errors",
  exclude_members: "Kecualikan Member",
  exclude_members_modal_header: "Kecualikan Member dari Dana/Fund",
  exclude_members_modal_sub_text: "Normalnya SoundSys mendistribusikan ke semua anggota dengan mandat yang valid. Jika anggota tertentu memiliki lisensi langsung atau tidak boleh berpartisipasi dalam dana/fund ini, Anda dapat mengecualikannya di sini. Anggota terpilih akan dikeluarkan dari distribusi dana/fund ini.",
  expired_session: "Your session has expired! Please login",
  extras: "ekstra",
  field: "Field",
  fileName: "nama file",
  fileType: "file type",
  file_uploaded: "File uploaded!",
  filterFiles: "filter file",
  filterSoundRecordings: "filter sound recordings",
  filterTimePeriod: "filter time period",
  filters: "filters",
  finishSetup: "selesaikan setup",
  fixation_country: "negara rekaman",
  fixation_year: "tahun rekaman",
  forgot_your_password: "Forgot your password?",
  from: "dari",
  funds: "funds",
  generatePreDistributionReport: "generate pre distribution report",
  generateUnmatchedReport: "generate unmatched report",
  generatedReportWillBeSent: "generated report will be sent to you via email",
  genres: "genres",
  go_back: "kembali",
  go_to_users: "go to users",
  gross_amount: "Gross amount",
  hide: "hide",
  history: "history",
  ingested: "ingested",
  ingestionStats: "statistik konsumsi",
  invalid_data_range: "Invalid date range",
  invalid_split_range: "The split value should be in the range 0-100",
  invalid_split_value: "Invalid split value",
  invalid_time_format: "Invalid time format",
  invalidateSource: "invalidate source",
  invalidateSourceInfo: "Warning. You are removing this instance data. It will no longer appear in the UI.",
  invalidatedSource: "source invalidated",
  isEligible: "berhak",
  isrc: "ISRC",
  item: "Item",
  landed: "landed",
  landed_sound_recordings: "landed sound recordings",
  lang_of_perf: "Language of performance",
  language: "bahasa",
  licensee: "penerima lisensi",
  linked: "linked",
  log_in: "log in",
  login: "login",
  logout: "logout",
  makeAClaim: "buat claim",
  manually_created: "manually created",
  manually_linked: "manually linked",
  manually_matched: "manually matched",
  match: "match",
  matched: "matched",
  matchingStats: "statistik yang cocok",
  member: "member",
  memberProfile: "profile member",
  memberSociety: "Anggota",
  member_not_defined: "member perusahaan belum ditentukan",
  member_saved: "Member saved",
  members: "members",
  missing_required_fields: "Missing required fields",
  myProfile: "profile saya",
  name: "nama",
  name_and_last_name: "nama depan & belakang",
  name_and_last_name_not_defined: "nama depan dan belakang belum ditentukan",
  nationality: "Kewarganegaraan",
  net_amount: "Net Amount",
  newDistribution: "distribusi baru",
  new_member_signup: "sign up member baru",
  no: "tidak",
  nothingToAdd: "Nothing to add",
  notifications: "notifications",
  num_users: "jumlah pengguna",
  optional: "optional",
  orSelectCustomDateRange: "Atau pilih custom date range",
  organization: "perusahaan /organization",
  other_deductions_pct: "Other deductions percentage",
  overclaimed: "overclaimed",
  password: "password",
  password_recovery: "Password recovery",
  payee: "payee",
  pending: "pending",
  pending_for_validation: "pending for validation",
  people: "people",
  period: "Titik",
  placeholderSoundRecording: "This is a sound recording created from a usage log.",
  play_count: "hitungan bermain",
  playlist_not_found: "Playlist file not found",
  playlist_rematching: "Playlist files re-matching",
  playlist_rematching_check: "Select this to re-match all playlist files included in this distribution.",
  playlist_rematching_desc: "By default the distribution engine will use current matching on all selected playlist files.",
  playlist_set_allocable: "Playlist Set Allocable",
  playlist_will_be_matched_again: "Playlist will be matched again",
  playlists: "playlists",
  please_indicate_a_recovery_email: "Please indicate a recovery email",
  preDistributionWarning: "Only duration based playlist will be used for the pre-distribution report",
  processing: "processing",
  proposedCandidates: "Candidates yang diusulkan",
  proprietary_id: "id milik / Diunggah oleh",
  provider_id: "Provider id",
  re_allocate: "re-allocate",
  readyForDistribution: "siap untuk distribusi",
  reason: "Reason",
  recording_unclaimed: "Recording Unclaimed",
  regitry_line_1: "Your application akan di review",
  regitry_line_2: "Setelah disapproved anda akan menerima email untuk men setup password",
  regitry_line_3: "stay tuned kuy!",
  regitry_line_4: "Anda akan diupdate secepatnya!",
  releaseNames: "nama album",
  remove: "hapus",
  removeAllClaimsQuestion: "Apa anda ingin menghapus semua sound recordings dari claim list?",
  removeClaim: "cabut claim",
  remove_all: "Hapus semua",
  repertoire: "Data Lagu",
  rightOwner: "right owner",
  rightOwners: "right owners",
  rightPeriod: "right period",
  rightTypes: "tipe right",
  rights: "rights",
  rule: "rule",
  save: "simpan",
  saveAsDraft: "simpan sebagai draft",
  save_member: "Save Member",
  save_member_warning: "Mengubah mandates/use-types untuk member ini akan memperbarui klaim yang ada. Perubahan ini dapat memakan waktu beberapa jam untuk diterapkan pada database. Apa anda yakin?",
  search: "search",
  search_candidates: "search candidates",
  select: "select",
  selectFileType: "Select File Type",
  selectFunds: "pilih funds",
  selectMember: "Select member",
  selectPayee: "pilih payer",
  selectPlaylists: "pilih playlist",
  selectRightOwner: "pilih right owner",
  selectRightTypes: "pilih right types",
  selectRule: "select rule",
  selectStatus: "pilih status",
  selectUseType: "tipe penggunaan yang dipilih",
  select_all: "select all",
  select_date: "select date",
  select_date_range: "select date range",
  select_member: "pilih member",
  select_members: "Select members",
  select_members_to_participate: "Select members to participate",
  select_type: "pilih tipe",
  send: "Send",
  send_notifications: "send notifications",
  setupNewDistribution: "setup distribusi baru",
  show: "show",
  showIneligible: "Show ineligible",
  show_hidden: "show hidden",
  show_inactive: "Show inactive",
  sign_up: "daftar",
  signup_header: "Isi detail anda. Akun anda akan di review terlebih dahulu",
  society: "society",
  soundRecordingDetail: "detail sound recording",
  soundRecordingDetails: "detail sound recording",
  soundRecordings: "sound recordings",
  soundSysDatabase: "database SoundSys",
  sound_recording_saved: "Sound Recording Saved!",
  sound_recordings_claimed: "Sound Recordings Claimed",
  soundrecordingDetail: "detail sound recording",
  source: "source",
  sourceMetadata: "source metadata",
  split: "split",
  status: "status",
  submittedBy: "disubmit oleh",
  tax_deductions_pct: "Tax deduction percentage",
  this_user_will_receive_all_notifications: "this user will receive all notifications",
  this_user_will_receive_no_notifications: "this user will receive no notifications",
  time_period: "Periode Distribusi",
  title: "judul",
  to: "ke",
  total: "total",
  total_unique: "total unique",
  type: "tipe",
  un_select_all: "Pilih Semua",
  unclaimed: "unclaimed",
  underclaimed: "di bawah diklaim",
  unmatched: "unmatched",
  unmatched_no_duplicates: "unmatched no duplicates",
  unmatched_ready_for_distribution: "unmatched ready for distribution",
  upload: "Upload",
  uploadDate: "tanggal upload",
  uploadFunds: "upload funds",
  uploadProRataFile: "upload file pro rata",
  uploads: "uploads",
  usageType: "usage types",
  usages: "Penggunaan",
  useReleaseMatchingInfo: "Force using Album info while matching. WARNING: This could create false positives",
  useType: "use type",
  userProfile: "User Profile",
  user_data: "User data",
  user_saved: "User saved",
  user_type_not_defined: "user type belum ditentukan",
  username: "username",
  users: "user",
  validate: "validasi",
  value: "nilai",
  version: "version",
  versionTitle: "versi judul",
  view: "view",
  view_excluded_members: "View Excluded Members",
  view_selected_members: "view selected members",
  view_selected_playlists: "view selected playlists",
  worldwide: "worldwide",
  year: "Tahun",
  yes: "iya",
}
